// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__25Ruw","footerRow":"footer_footerRow__2U8ol","icons":"footer_icons__dFSXk"};